import { useState } from "react";
import styles from "./VenueSpaceGallery.module.css";

export default function VenueSpaceGallery({ spaces }) {

  const images = spaces.flatMap(space =>
    (space.images || []).map(img => ({
      image: img.image,
      name: space.name,
    }))
  );

  const [current, setCurrent] = useState(0);

  if (images.length === 0) return null;

  const prev = () => {
    setCurrent(prev =>
      prev === 0 ? images.length - 1 : prev - 1
    );
  };

  const next = () => {
    setCurrent(prev =>
      prev === images.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <section className={styles.section}>

      <h2 className={styles.heading}>
        Venue Space Gallery
      </h2>

      <div className={styles.carousel}>

        <button
          className={`${styles.arrow} ${styles.left}`}
          onClick={prev}
        >
          &#10094;
        </button>

        <div className={styles.imageWrapper}>

          <img
            src={images[current].image}
            alt={images[current].name}
            className={styles.image}
          />

          <div className={styles.overlay}>
            {images[current].name}
          </div>

        </div>

        <button
          className={`${styles.arrow} ${styles.right}`}
          onClick={next}
        >
          &#10095;
        </button>

      </div>

    </section>
  );
}